import { render, staticRenderFns } from "./stepFour.vue?vue&type=template&id=d64fde36&scoped=true&"
import script from "./stepFour.vue?vue&type=script&lang=js&"
export * from "./stepFour.vue?vue&type=script&lang=js&"
import style0 from "./stepFour.vue?vue&type=style&index=0&id=d64fde36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64fde36",
  null
  
)

export default component.exports